import { Accept } from "react-dropzone";
import DocIcon from "@root/assets/icons/doc-icon.svg";
import PdfIcon from "@root/assets/icons/pdf-icon.svg";
import XlsIcon from "@root/assets/icons/xls-icon.svg";

export const MAX_FILES: number = 9;
export const MAX_FILE_SIZE: number = 1024 * 1024 * 1024; // 1GB in bytes

export const ALLOWED_FILE_TYPES: AllowedFileTypes = {
  "application/pdf": { ext: ".pdf", color: "red.500" },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": {
    ext: ".docx",
    color: "blue.500",
  },
  "application/msword": { ext: ".doc", color: "blue.500" },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": {
    ext: ".xlsx",
    color: "green.500",
  },
  "application/vnd.ms-excel": { ext: ".xls", color: "green.500" },
};

export const acceptedFileTypes: Accept = {
  "application/pdf": [".pdf"],
  "application/msword": [".doc"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ],
};

// Re-export the comprehensive file size formatter from utils
export { formatFileSizeSmart as formatFileSize } from "@root/utils/file-size-helper";

export const getFileIcon = (fileExtension: string): string => {
  switch (fileExtension) {
    case "pdf":
      return PdfIcon;
    case "doc":
    case "docx":
      return DocIcon;
    case "xls":
    case "xlsx":
      return XlsIcon;
    default:
      return DocIcon; // Default icon
  }
};
